<template>
  <router-link v-if="item.route" :to="{ name: item.route }">
    <slot></slot>
  </router-link>
  <a v-else :href="item.href" target="_blank" rel="noopener">
    <slot></slot>
  </a>
</template>

<script>
// Links a menu item from `_helpers/menu.js`: an app route, or the website in a new tab.
export default {
  name: 'MenuLink',
  props: {
    item: { type: Object, required: true }
  }
}
</script>
